module.exports = __webpack_public_path__ + "assets/88a10e1839b4a6fc6e9cbfe4aa4a3815.png";